import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useBranding } from "../context/BrandingContext";
import { errDetail, BACKEND_URL } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Lock, Mail } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const { siteName, logoUrl } = useBranding();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(errDetail(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen">
      <div className="hidden w-1/2 flex-col justify-between bg-[#0B1F3A] p-12 lg:flex">
        <div className="flex items-center gap-3">
          {logoUrl ? (
            <img src={`${BACKEND_URL}${logoUrl}`} alt={siteName} className="h-10 w-10 object-contain" />
          ) : (
            <div className="flex h-10 w-10 items-center justify-center bg-[#D4AF37] font-heading text-lg font-bold text-[#0B1F3A]">
              {(siteName || "K").charAt(0).toUpperCase()}
            </div>
          )}
          <div>
            <p className="font-heading text-lg font-semibold text-white">{siteName}</p>
            <p className="text-[10px] uppercase tracking-[0.2em] text-white/50">Ticari Yönetim Sistemi</p>
          </div>
        </div>
        <div>
          <h1 className="font-heading text-4xl font-semibold leading-tight text-white">
            {siteName}<br />
            <span className="text-[#D4AF37]">anılarınıza sanat katar</span>
          </h1>
          <p className="mt-6 max-w-md text-white/60">
            {siteName} Kalite, Güven, Sanat.
          </p>
        </div>
        <div>
          <p className="text-xs text-white/40">© {new Date().getFullYear()} {siteName}</p>
          <p className="mt-1 text-[10px] text-white/30" data-testid="powered-by-footer-login">Powered By KMS Media Ajans</p>
        </div>
      </div>
      <div className="flex w-full items-center justify-center bg-[#F9FAFB] px-6 lg:w-1/2">
        <div className="w-full max-w-md border border-gray-200 bg-white p-8 md:p-10">
          <div className="mb-8 flex items-center gap-3 lg:hidden">
            {logoUrl ? (
              <img src={`${BACKEND_URL}${logoUrl}`} alt={siteName} className="h-9 w-9 object-contain" />
            ) : (
              <div className="flex h-9 w-9 items-center justify-center bg-[#D4AF37] font-heading font-bold text-[#0B1F3A]">
                {(siteName || "K").charAt(0).toUpperCase()}
              </div>
            )}
            <p className="font-heading font-semibold text-[#0B1F3A]">{siteName}</p>
          </div>
          <h2 className="font-heading text-2xl font-semibold text-[#0B1F3A]">Giriş Yap</h2>
          <p className="mt-1 text-sm text-gray-500">Hesabınızla oturum açın</p>
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <Label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-gray-500">E-posta</Label>
              <div className="relative">
                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <Input data-testid="login-email-input" type="email" required className="rounded-none pl-9"
                  placeholder="ornek@firma.com" value={email} onChange={(e) => setEmail(e.target.value)} />
              </div>
            </div>
            <div>
              <Label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-gray-500">Şifre</Label>
              <div className="relative">
                <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <Input data-testid="login-password-input" type="password" required className="rounded-none pl-9"
                  placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} />
              </div>
            </div>
            {error && (
              <p data-testid="login-error" className="border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-600">{error}</p>
            )}
            <Button data-testid="login-submit-button" type="submit" disabled={loading}
              className="h-11 w-full rounded-none bg-[#0B1F3A] font-semibold text-white transition-colors duration-200 hover:bg-[#132c4f]">
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
